import {
  MenuCockpit,
  MenuCockpitFilled,
  MenuDevicePlus,
} from "@/assets/icons/icons";

export const partnerNavigationItems = [
  {
    icon: <MenuCockpit />,
    activeIcon: <MenuCockpitFilled />,
    text: "layout.menu.items.cockpit",
    target: "/partner/cockpit",
  },
  {
    icon: <MenuDevicePlus />,
    activeIcon: <MenuDevicePlus />,
    text: "partnerPortal:addDevice.title",
    target: "/partner/add-sim",
  },
] as const;

export type PartnerNavigationItem = (typeof partnerNavigationItems)[number];
